<!--  -->
<template>
  <div class="body" :style="{ height: layoutPageHeight + 'px' }">
    <template v-if="questionList.length != 0">
      <div class="row1">
        <div class="row1-title">常见问题</div>
        <el-input class="inputCla" @keyup.enter.native="getQuestion" :placeholder="`请输入`" v-model="inputValue" clearable> </el-input>
      </div>
      <div class="row2">
        <div class="column1">
          <el-tree :expand-on-click-node="false" :data="questionList" :props="defaultProps" @node-click="scrollToEle" :default-expand-all="true">
            <span class="custom-tree" :class="data.is_search == 1 ? 'custom-tree-node' : ''" slot-scope="{ data }">
              {{ data.title }}
            </span>
          </el-tree>
        </div>
        <div class="column2" :style="{ height: layoutPageHeight - 80 + 'px' }">
          <div v-for="(item, index) in contentList" :key="item.id" class="rich-text-box">
            <!-- {{ item }} -->
            <div :class="item.is_search == 1 ? 'custom-tree-node' : ''" class="richText" :id="'id' + item.id">{{ index + 1 }}.{{ item.title }}</div>
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
    </template>
    <el-empty v-else :description="`暂无数据`"></el-empty>
  </div>
</template>

<script>
import { faqCatalog, faqByType } from '@/api.js';
export default {
  data() {
    return {
      inputValue: '',
      layoutPageHeight: 0,
      questionList: [],
      contentList: [],
      defaultProps: {
        children: 'questions',
        label: 'title',
      },
    };
  },
  created() {
    this.getQuestion();
  },
  mounted() {
    // 获取样式为layout-page的第一个元素的高度
    this.layoutPageHeight = document.querySelector('.layout-page').offsetHeight - 30;
  },
  methods: {
    // 获取问题
    getQuestion() {
      let query = {
        search: this.inputValue,
      };
      this.$request('get', faqCatalog, query).then((res) => {
        if (res) {
          for (let i = 0; i < res.length; i++) {
            res[i].title = res[i].type_name;
          }
          this.questionList = res;
          // 查找被搜索命中的第一个问题,然后跳转显示
          let index = res.findIndex(i=>{
            return i.questions.find(j=>{
              return j.is_search == 1
            })
          })
          if(index<1){
            index = 0
          }
          this.contentList = [] //置空，要不然滚动条不会回到顶部
          this.type = index // 设置当前在哪个type
          this.getContent(res[index]).then((res) => {
            this.contentList = res;
          });
        }
      });
    },
    // 获取内容
    getContent(data) {
      let query = {
        type: data.type,
      };
      let isSelect = false;
      return this.$request('get', faqByType, query).then((res) => {
        this.questionList.forEach((itemA) => {
          // 对被命中的数据进行修改
          itemA.questions.forEach((itemB) => {
            res.forEach((itemC) => {
              if (itemB.id == itemC.id && itemB.is_search == '1') {
                itemC.is_search = '1';
                if (!isSelect && this.inputValue) { // 当输入框里没有值的时候也不用跳转
                  this.scrollToEle({
                    // 对第一个被命中的数据进行跳转
                    type: itemA.type,
                    id: itemB.id,
                  });
                }
                isSelect = true;
              }
            });
          });
        });
        return res;
      });
    },
    scrollToEle(data) {
      if (this.type == data.type) {
        // 点击的是当前tab下的另一个标题时
        let eleId = 'id' + data.id;
        const targetElement = document.getElementById(eleId);
        if (targetElement) {
          targetElement.scrollIntoView();
        }
        return;
      } else {
        // 点击的是另一个tab时
        this.contentList = [];
        this.getContent(data).then((res) => {
          this.contentList = res;
          this.$nextTick(() => {
            // 当点击另一个tab的时候，要跳转到对应的问题
            this.scrollToEle({
              type: this.type,
              id: data.id,
            });
          });
        });
      }
      this.type = data.type;
    },
  },
};
</script>

<style scoped>
.body {
  background: #fff;
}
.row1 {
  display: flex;
  justify-content: space-between;
  height: 80px;
  padding: 20px;
}
.row1-title {
  font-size: 25px;
}
.inputCla {
  width: 400px;
}
.row2 {
  display: flex;
}
.column1 {
  width: 350px;
  border-right: 2px solid #888;
  margin-bottom: 20px;
}
.column2 {
  flex: 1;
  height: 100%;
  overflow: auto;
  padding: 0 20px;
}
.richText {
  font-size: 25px;
  margin-bottom: 20px;
}
.custom-tree-node {
  background: #ccc;
}
.custom-tree {
  width: 272px; /* 设置容器宽度 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.rich-text-box {
  margin-bottom: 20px;
}
</style>
